import { View } from 'foundations-components/components/View';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { CardSection, CardHeader, CardWrapper } from 'foundations-components/transitional/components/Card';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import RecentCertifications from './RecentCertifications';
import UpcomingExpirations from './UpcomingExpirations';
import OverviewSectionHeader from './OverviewSectionHeader';
import { ACTIVE_CERTIFICATIONS_BY_TEAM_PATH, TEAM_MEMBERS_PATH } from '../../constants/routes';
import { trackViewAllClick } from '../../utils/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TeamMembersOverview = () => {
  const {
    isLaptop
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "1000",
    children: [/*#__PURE__*/_jsx(OverviewSectionHeader, {
      button: /*#__PURE__*/_jsx(UIRouterButton, {
        onClick: () => trackViewAllClick('all-team-members'),
        size: "small",
        to: TEAM_MEMBERS_PATH,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.overview.teamMembers.viewAll"
        })
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.teamMembers.description"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.teamMembers.title"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(CardGrid, {
        columns: isLaptop ? 1 : 2,
        gutterSize: 20,
        children: [/*#__PURE__*/_jsxs(CardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(CardHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.teamMembers.recentCertifications.title"
            }),
            titleSize: "sm",
            toolbar: /*#__PURE__*/_jsx(RouterLink, {
              onClick: () => trackViewAllClick('most-recent-certifications'),
              to: `${ACTIVE_CERTIFICATIONS_BY_TEAM_PATH}?sortBy=COMPLETED_AT&sortOrder=DESC`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.recentCertifications.viewAll"
              })
            })
          }), /*#__PURE__*/_jsx(CardSection, {
            children: /*#__PURE__*/_jsx(RecentCertifications, {})
          })]
        }), /*#__PURE__*/_jsxs(CardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(CardHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.title"
            }),
            titleSize: "sm",
            toolbar: /*#__PURE__*/_jsx(RouterLink, {
              onClick: () => trackViewAllClick('upcoming-expirations'),
              to: `${ACTIVE_CERTIFICATIONS_BY_TEAM_PATH}?sortBy=EXPIRES_AT&sortOrder=ASC`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.viewAll"
              })
            })
          }), /*#__PURE__*/_jsx(CardSection, {
            children: /*#__PURE__*/_jsx(UpcomingExpirations, {})
          })]
        })]
      })
    })]
  });
};
export default TeamMembersOverview;